<div class="row">
  <div class="createCPPOuter">

    <div class="create-cpp-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <!--<a href="javascript:void(0)" routerLink="/cpp/landing-data">Quote</a>-->
              <a href="javascript:void(0)" (click)="redirectToLanding()">Quote</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span>Quote Number: {{quoteHeaderInfo?.quoteNumber}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <!--Ship to - Confirmation Email Section-->
        <div class="row">
          <!--Sold To Select List-->
          <div class=" col-md-4 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
            <ng-select name="ddlSoldTo"
                       [items]="soldToFacility"
                       class="custom-select-grower grower-add-drop"
                       [class.ng-select-disabled]="!soldToAccount"
                       [virtualScroll]="true"
                       [(ngModel)]="soldToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Sold To:"
                       [loading]="soldToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class=" col-md-4 material-select withBordr">
            <ng-select name="ddlShipTo"
                       [items]="shipToFacilityList"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="shipToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="isEditMode || readOnlyAccess"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class=" col-md-4 material-select withBordr" [class.cpp-create-soldTo]="!deliverToAnotherLocation">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToList"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="deliverToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="(!deliverToAnotherLocation || shipToAccount ==null || shipToAccount ==undefined || readOnlyAccess)"
                       placeholder="Deliver To:"
                       [loading]="deliverToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getDeliverTo($event)"
                       (clear)="getDeliverTo($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="pt-1 checkbox-color">
              <mat-checkbox class="custom-checkbox"
                            [disabled]="readOnlyAccess"
                            [style.display]=""
                            [checked]=""
                            (change)="UpdateDeliverToSelection($event.checked)"
                            (input)="hasHeaderInfoChanged('Customer Pickup');"
                            [indeterminate]=""
                            [(ngModel)]="deliverToAnotherLocation"></mat-checkbox>
              I want this delivered to another location.
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 specialInst padding-t4">
            <mat-form-field class="example-full-width">
              <label class="checkbox-color">Shipping Instructions:</label>
              <textarea style="resize:none;height:auto;" matInput rows="5"
                        (input)="hasHeaderInfoChanged('Special Instructions');"
                        [maxLength]="500"
                        [readonly]="readOnlyAccess"
                        [(ngModel)]="specialInstructionText"></textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 purchaseOrder margin-t12">
            <mat-form-field class="wide100">
              <input matInput type="text" name="purchaseOrder" (keypress)="keyPressAlphaNumeric($event)"
                     (input)="hasHeaderInfoChanged('PO');"
                     [(ngModel)]="purchaseOrder"
                     [readonly]="readOnlyAccess"
                     placeholder="Customer PO#:"
                     [maxLength]="25">
            </mat-form-field>
          </div>
          <div class="col-md-3 purchaseOrder margin-t12" *ngIf="isSubscriptionAccess">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Non-Subscriber Email:</mat-label>
              <input matInput type="email" name="accountEmail"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [(ngModel)]="accountEmail"
                     [readonly]="readOnlyAccess"
                     [pattern]="emailPattern"
                     (keyup)="validateEmail()"
                     (input)="hasHeaderInfoChanged('Email Address');"
                     email="true">
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 checkbox-color margin-t35">
            Customer Pickup:  <mat-checkbox #CustomerPickupCheck class="custom-checkbox margin-l10"
                                            [disabled]="readOnlyAccess"
                                            [style.display]=""
                                            [checked]=""
                                            (input)="hasHeaderInfoChanged('Customer Pickup');"
                                            [indeterminate]=""
                                            [(ngModel)]="isCustomerPickup"
                                            matTooltip="Select For Customer Pickup" [matTooltipPosition]="'above'"></mat-checkbox>
          </div>
          <div class="col-md-3 checkbox-color margin-t35">
            Show Products w/open QTY:  <mat-checkbox #ShowOpenOnlyCheck class="custom-checkbox margin-l10"
                                                     [disabled]="readOnlyAccess"
                                                     [style.display]=""
                                                     [checked]="false"
                                                     [indeterminate]=""
                                                     [(ngModel)]="isShowOpenOnly"
                                                     (change)="showOpenOnly()"
                                                     matTooltip="Show Products w/open QTY" [matTooltipPosition]="'above'"></mat-checkbox>
          </div>
        </div>
      </div>

      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer" id="cppOrderView">
              <table mat-table #productTable [dataSource]="quoteProductItemsDataSource" multiTemplateDataRows matSort matSortDirection="desc" class="matTables productTable resultTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th>
            </div>
            <div *ngIf="column=='viewDetail'"><th mat-header-cell *matHeaderCellDef style="color:white" class="package text-center">View Detail</th></div>
            <div *ngIf="column=='totalQuoteQty'"><th mat-header-cell *matHeaderCellDef class="totalQuoteQty text-center">Total Quoted QTY</th></div>
            <div *ngIf="column=='remainingQty'"><th mat-header-cell *matHeaderCellDef class="remainingQty text-center">Remaining QTY</th></div>
            <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="package text-center">Package Size</th></div>
            <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Quantity</th></div>
            <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="orderUOMBlock text-center">Order UOM</th></div>
            <div *ngIf="column=='itemTotal'"><th mat-header-cell *matHeaderCellDef class="itemTotal text-center">Item Total</th></div>
            <div *ngIf="column=='deliveryDate'"><th mat-header-cell *matHeaderCellDef class="deliveryDateBlock text-center">Requested Arrival Date</th></div>

            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='product'">
                <div class="order-info">
                  <p>{{element.itemVendorName}}</p>
                  <p class="grower-name">{{element.itemDescription}}</p>
                  <p> <span *ngIf="element.yourPrice!='' && plAccess == true && element.yourPrice!=null && element.yourPrice!=0" class="growerUnit">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
                  <!--<p> <span class="paymentTerm" *ngIf="plAccess == true && element.paymentTermDescription!='' && element.paymentTermDescription!=null && element.paymentTermDescription!=undefined">{{element.paymentTermDescription }}</span></p>-->
                </div>
              </div>

              <div *ngIf="column=='viewDetail'" (click)="showProductDetails(element);" class="showHideDetails">
                <a>{{element.isProductDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
              </div>

              <div *ngIf="column=='totalQuoteQty'" class="totalQuoteQty text-center largeTableTxt">
                {{element.totalQuoteQty}}
              </div>
              <div *ngIf="column=='remainingQty'" class="remainingQty text-center largeTableTxt">
                {{element.remainingQty}}
              </div>
              <div *ngIf="column=='packageSize'" class="packageSize text-center largeTableTxt">
                {{element.packageSize}}
              </div>

              <div *ngIf="column=='quantity'" class="quantityBlock text-center">
                <div>
                  <button *ngIf="!readOnlyAccess" class="plus-minus-btn minusBtn" (click)="quoteUnitChange('decrease',element)"> - </button>
                  <input [readonly]="readOnlyAccess" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)"
                         [(ngModel)]="element.quantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.quantity < 0 || element.quantity == '')}" />
                  <button *ngIf="!readOnlyAccess" class="plus-minus-btn plusBtn" (click)="quoteUnitChange('increase',element)"> + </button>
                </div>
              </div>

              <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt">
                {{element.orderUOM}}
              </div>
              <div *ngIf="column=='deliveryDate'" class="text-center largeTableTxt">
                {{element.deliveryDate | date:'MM/dd/yyyy'}}
              </div>
            </td>
            </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div [style.display]="element.isProductDetailDisplayed ? 'block' : 'none'">
                  <div class="cpp-prod-info">
                    <table style="width:100%">
                      <thead>
                        <tr>
                          <th width="15%" class="text-left">Item #</th>
                          <th width="17%">GTIN</th>
                          <th width="17%">Product Line</th>
                          <th width="17%">Active Ingredients</th>
                          <!--<th width="10%">National Price</th>-->
                          <th width="17%">Pallet Quantity</th>
                          <th width="17%">Restricted Use</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td width="15%" class="text-left"><p>{{element.itemNumber}}</p></td>
                          <td width="17%"><p>{{element.gtin}}</p></td>
                          <td width="17%"><p>{{element.productLine}}</p></td>
                          <td width="17%"><p>{{element.activeIngredient}}</p></td>
                          <!--<td width="10%"><p> {{element.nationalPrice | number:'1.4-4'}}</p></td>-->
                          <td width="17%"><p>{{element.palletQuantity | number:'1.4-4'}}</p></td>
                          <td width="17%"><p>{{element.restrictedUse}}</p></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
            <div *ngIf="quoteProductItemsDataSource == undefined || quoteProductItemsDataSource?.data.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="xs-mt-15">
        <p class="xs-mb-0 erp-order">This quote was put together as a packaged offer, there are <b>NO RETURNS</b>.</p>
      </div>
    </div>
  </div>

  <!--Error section on table-->
  <div class="common-error-block cpp-create" *ngIf="showErrorBlock && errorMsgs.length > 0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row padding-l20">
      <div class="col-md-12" style="display: contents;">
        <!--<button mat-raised-button class="btns" [disabled]="(!isPlaceOrderEnable)" (click)="placeOrder()" [style.display]="'inline-block' ">Place Order</button>-->
        <button mat-raised-button class="btns" color="primary" (click)="saveDraft()" [disabled]="!isSaveOrderDraftEnable" [style.display]="'inline-block'">Save Draft</button>
      </div>
    </div>
  </div>
</div>
</div>
